module.exports = __webpack_public_path__ + "asset/image-iconCategoryClothes-e1e3a010e8643592.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryClothes.svg
// module id = yn4m
// module chunks = 0